import {useEffect, useState} from "react";
import axios from 'axios';
import Pagination from "../../elements/Pagination";
import Modal from '../../elements/Modal';
import {setError} from "../../../slices/error/ErrorSlice";
import {useDispatch} from "react-redux";

export default function Fkp () {
    const dispatch = useDispatch();

    const[fkpList, setFkpList] = useState([]);
    const[params, setParams] = useState({
        name: '',
        code: ''
    });
    const[pagination, setPagination] = useState({
        currentPage: 1,
        pagesCount: 0
    });

    useEffect(() => {
        getFkp();
    }, [pagination.currentPage]);

    useEffect(() => {
        let timeout = setTimeout(() => {
            getFkp();
        }, 1000)

        return () => {
            clearTimeout(timeout);
        };
    }, [params]);

    function getFkp() {
        axios.get('/api/voc/fkp-list', {params: {...params, page: pagination.currentPage}})
            .then(res => {
                setFkpList(res.data);
                let headers = {
                    currentPage:    Number(res.headers['x-pagination-current-page']),
                    pagesCount:     Number(res.headers['x-pagination-pages-count'])
                }
                setPagination(headers);
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function changeParamsHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setParams({...params, [fieldName]: value});
    }

    function setCurrentPage(page) {
        setPagination({...pagination, currentPage: page});
    }

    let rows = fkpList.map(item =>
        <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.code}</td>
            <td>{item.name}</td>
            <td>{item.address}</td>
            <td>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil hover" viewBox="0 0 16 16">
                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
            </td>
            <td>
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
        </tr>
    )

    return (
        <>
            <Modal>

            </Modal>

            <h1>ФКП</h1>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col" style={{width: 95}}>Код ФКП</th>
                    <th scope="col">Наименование</th>
                    <th scope="col">Адрес</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                <tr>
                    <td></td>
                    <td><input onChange={changeParamsHandler} type="text" name='code' className="form-control" id="search_fkp" placeholder='Поиск'/></td>
                    <td><input onChange={changeParamsHandler} type="text" name='name' className="form-control" id="search_name" placeholder='Поиск'/>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </table>

            <Pagination pagesCount={pagination.pagesCount} currentPage={pagination.currentPage} setPageHandler={setCurrentPage}/>
        </>
    )
}